import { CloseIcon } from "@chakra-ui/icons";
import {
    Box, Button, Checkbox, Flex, FormControl, FormErrorMessage, FormLabel,
    IconButton, Input, Modal, ModalBody, ModalContent, ModalFooter,
    ModalHeader, ModalOverlay, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Select, Spinner, Table, Tbody, Td, Text,
    Th,
    Thead,
    Tooltip,
    Tr
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { crmConstant } from "services/Crm/constant";
import "common/assets/css/convert.css";
import { Formik, Form } from "formik";
import { getApi } from "common/services/api";
import { useEffect, useState, useRef } from "react";
import StatusDropdown from "../statusDropdown";
import { constant } from "common/constant";
import { ConvertLeadSchema } from "services/Crm/schema/convertLeadSchema";
import { postApi } from "common/services/api";
import { toast } from "react-toastify";



const ConvertModal = ({
  onClose,
  isOpen,
  title,
  data,
  leadId,
  fetchData = () => {},
}) => {
    const user = useSelector((state) => state.user.user);
    const [accountModuleId, setAccountModuleId] = useState('');
    const [existingAcounts, setExistingAccounts] = useState([]);
    const accountModuleName = "Accounts";
    const contactModuleName = "Contacts";
    const [alreadyAccountExist, setAlreadyAccountExist] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [isAccountConfirmed, setIsAccountConfirmed] = useState(false);
    const [accountFields, setAccountFields] = useState([])
    const [accountFieldsValue, setAccountFieldsValue] = useState([])
    const formControlRef = useRef(null);
    const tableRef = useRef(null);

    const [alreadyContactExist, setAlreadyContactExist] = useState(false);
    const [showContactTable, setShowContactTable] = useState(false);
    const [isContactConfirmed, setIsContactConfirmed] = useState(false);
    const [existingContacts, setExistingContacts] = useState([]);
    const [contactFields, setContactFields] = useState([]);
    const [contactFieldsValue, setContactFieldsValue] = useState([]);
    const contactFormControlRef = useRef(null);
    const contactTableRef = useRef(null);

    // account table
    useEffect(() => {
        function handleClickOutside(event) {
            if (
                showTable &&
                tableRef.current &&
                !tableRef.current.contains(event.target) &&
                formControlRef.current &&
                !formControlRef.current.contains(event.target)
            ) {
                setShowTable(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showTable]);

    // contact table
    useEffect(() => {
        function handleContactClickOutside(event) {
            if (
                showContactTable &&
                contactTableRef.current &&
                !contactTableRef.current.contains(event.target) &&
                contactFormControlRef.current &&
                !contactFormControlRef.current.contains(event.target)
            ) {
                setShowContactTable(false);
            }
        }

        document.addEventListener("mousedown", handleContactClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleContactClickOutside);
        };
    }, [showContactTable]);

    // existing account details
    useEffect(() => {
        if (title === crmConstant.lead) {
            const fetchAccountModuleId = async () => {
                const result = await getApi(`api/custom-field/?moduleName=${accountModuleName}`);
                const customField = result?.data?.[0];
                if (customField?._id) {
                    setAccountModuleId(customField._id);
                    setAccountFields(customField.fields);
                    fetchAccount(customField._id, customField.fields);
                }
            };

            const fetchAccount = async (id, fields) => {
                let result = await getApi(`api/form?moduleId=${id}`);
                const responseData = result?.data?.data;

                if (result.status === 200 && Array.isArray(responseData)) {
                    const names = responseData.map(item => item.accountName).filter(Boolean);
                    setExistingAccounts(names);

                    const normalizedCompanyName = (data?.companyName || '').toLowerCase().replace(/\s/g, '');
                    const normalizedAccountNames = names.map(name => name.toLowerCase().replace(/\s/g, ''));

                    if (normalizedAccountNames.includes(normalizedCompanyName)) {
                        setAlreadyAccountExist(true);
                        const matched = responseData.filter(
                            item => item.accountName?.toLowerCase().replace(/\s/g, '') === normalizedCompanyName
                        );
                        setAccountFieldsValue(matched);
                    } else {
                        setAlreadyAccountExist(false);
                        setAccountFieldsValue([]);
                    }
                }
            };

            fetchAccountModuleId();
        }
    }, [title, data?.companyName]);

    const [selectedAccountId, setSelectedAccountId] = useState(null);

    const handleCheckboxChange = (id) => {
        setSelectedAccountId(prev => (prev === id ? null : id));
    };

    const handleDone = () => {
        if (selectedAccountId) {
            setShowTable(false);
            setIsAccountConfirmed(true);
        }
    };

    // existing contact details

    useEffect(() => {
        // if (title === crmConstant.lead) {
        const fetchContactModuleId = async () => {
            const result = await getApi(`api/custom-field/?moduleName=${contactModuleName}`);
            const customField = result?.data?.[0];
            if (customField?._id) {
                // setAccountModuleId(customField._id);
                setContactFields(customField.fields);
                fetchContact(customField._id, customField.fields);
            }
        };



        const fetchContact = async (id, fields) => {
            let result = await getApi(`api/form?moduleId=${id}`);
            const responseData = result?.data?.data;

            if (result.status === 200 && Array.isArray(responseData)) {
                const contactName = responseData.map(item => item.contactName).filter(Boolean);
                setExistingContacts(contactName);

                const normalizedLeadName = (data?.leadName || '').toLowerCase().replace(/\s/g, '');
                const normalizedContactName = contactName.map(name => name.toLowerCase().replace(/\s/g, ''));

                if (normalizedContactName.includes(normalizedLeadName)) {
                    setAlreadyContactExist(true);
                    const matched = responseData.filter(
                        item => item.contactName?.toLowerCase().replace(/\s/g, '') === normalizedLeadName
                    );
                    setContactFieldsValue(matched);
                } else {
                    setAlreadyContactExist(false);
                    setContactFieldsValue([]);
                }
            }
        };


        fetchContactModuleId();
        // }
    }, [data?.leadName]);



    const [selectedContactId, setSelectedContactId] = useState(null);

    const handleContactCheckboxChange = (id) => {
        setSelectedContactId(prev => (prev === id ? null : id));
    };

    const handleContactDone = () => {
        if (selectedContactId) {
            setShowContactTable(false);
            setIsContactConfirmed(true)
        }
    }

    return (
        <Formik
            initialValues={{
                amount: "",
                dealName: "",
                closeDate: "",
                stage: "",
                showCreateOpportunity: false,
                showNewAccountContact: false,
                showExistingAccountList: false,
                showNewContact: false,
                showExistingContactList: false,
            }}
            validationSchema={ConvertLeadSchema}
            onSubmit={async (values, { setSubmitting }) => {
                const payload = {
                    leadId: leadId,
                    createAccount: !values.showExistingAccountList,
                    // createAccount: !alreadyAccountExist,
                    // createContact: !alreadyAccountExist ? true : values.showNewAccountContact,
                    createContact: !values.showExistingContactList,
                    createDeal: values.showCreateOpportunity,
                    ownerId: user?._id,
                };

                if (!alreadyAccountExist) {
                    payload.contactName = data?.leadName;
                    payload.companyName = data?.companyName;
                } else {
                    payload.selectedAccountId = selectedAccountId;
                }

                if (values.showCreateOpportunity) {
                    payload.dealData = {
                        dealName: values.dealName,
                        amount: values.amount,
                        closeDate: values.closeDate,
                        stage: values.stage
                    };
                }

                try {
                    const response = await postApi('api/lead/convertLead', payload);

                    if (response.status === 200) {
                        toast.success(crmConstant.leadConvertedSuccessfully)
                        fetchData();
                    } else {
                        toast.error(crmConstant.someThingWentWrong)
                    }
                } catch (error) {
                    toast.error(crmConstant.someThingWentWrong)
                } finally {
                    setSubmitting(false);
                    onClose();
                }
            }}
        >
            {({ values, errors, touched, handleChange, handleBlur, isSubmitting, setFieldValue }) => {

                const isSubmitDisabled = (() => {
                    const dealFieldsMissing = !values.dealName || !values.closeDate || !values.stage;
                    const isOpportunityEnabled = values.showCreateOpportunity ? !dealFieldsMissing : false;

                    // Case 1: No existing account or contact
                    if (!alreadyAccountExist && !alreadyContactExist) {
                        return isSubmitting || (values.showCreateOpportunity && dealFieldsMissing) || Object.keys(errors).length > 0;
                    }

                    // Case 2: Existing account only
                    if (alreadyAccountExist && !alreadyContactExist) {
                        const isAccountValid = values.showNewAccountContact || values.showExistingAccountList;
                        return (
                            isSubmitting ||
                            !isAccountValid ||
                            (values.showCreateOpportunity && dealFieldsMissing) ||
                            (values.showExistingAccountList && !selectedAccountId) ||
                            Object.keys(errors).length > 0
                        );
                    }

                    // Case 3: Existing contact only
                    if (!alreadyAccountExist && alreadyContactExist) {
                        const isContactValid = values.showNewContact || values.showExistingContactList;
                        return (
                            isSubmitting ||
                            !isContactValid ||
                            (values.showCreateOpportunity && dealFieldsMissing) ||
                            Object.keys(errors).length > 0
                        );
                    }

                    // Case 4: Both account and contact exist 
                    const isAccountValid = values.showNewAccountContact || values.showExistingAccountList;
                    const isContactValid = values.showNewContact || values.showExistingContactList;

                    return (
                        isSubmitting ||
                        !isAccountValid ||
                        !isContactValid ||
                        (values.showCreateOpportunity && dealFieldsMissing) ||
                        (values.showExistingAccountList && !selectedAccountId) ||
                        Object.keys(errors).length > 0
                    );
                })();
                return (
                    <>
                        <Box >
                            <Modal className="mainContainer" size={"3xl"} onClose={onClose} isOpen={isOpen} isCentered>
                                <ModalOverlay />
                                <ModalContent>
                                    <ModalHeader className="convertModalHeader">
                                        {crmConstant.convert} {title}

                                        {title === crmConstant.lead && (
                                            <Text className="convertHeaderDetail">{`(${data?.leadName} - ${data?.companyName})`}</Text>
                                        )}
                                    </ModalHeader>

                                    <IconButton
                                        size="xs"
                                        className="closeIcon"
                                        onClick={onClose}
                                        icon={<CloseIcon />}
                                    />

                                    <Form>
                                        <ModalBody className="modalbody">

                                            {title === crmConstant.lead && (
                                                <>
                                                    <Flex flexDirection="column" gap="6px">
                                                        <>
                                                            {alreadyAccountExist ?
                                                                <>
                                                                    {alreadyAccountExist && (
                                                                        <Box>
                                                                            <Text className="label">Account with similar details in <b>Account Name</b> already exist.</Text>
                                                                            <FormControl ref={formControlRef} mt={"16px"} display="flex" gap={"6px"} alignItems="center">
                                                                                <Checkbox
                                                                                    name="showExistingAccountList"
                                                                                    isChecked={values.showExistingAccountList}
                                                                                    onChange={(e) => {
                                                                                        const checked = e.target.checked;
                                                                                        setFieldValue("showExistingAccountList", checked);
                                                                                        if (checked) {
                                                                                            setFieldValue("showNewAccountContact", false);
                                                                                            setShowTable(true);
                                                                                        } else {
                                                                                            setShowTable(false);
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                <FormLabel mr={0} className="label" mb="0">
                                                                                    Add to existing Account
                                                                                </FormLabel>
                                                                                <Text className="value">{data?.companyName}</Text>
                                                                            </FormControl>

                                                                            {values.showExistingAccountList && !alreadyContactExist && (
                                                                                <Text className="label">A new Contact {data?.leadName} will be created for the Account.</Text>
                                                                            )}

                                                                            <FormControl mt={"6px"} display="flex" gap={"6px"} alignItems="center">
                                                                                <Checkbox
                                                                                    name="showNewAccountContact"
                                                                                    isChecked={values.showNewAccountContact}
                                                                                    onChange={(e) => {
                                                                                        const checked = e.target.checked;
                                                                                        setFieldValue("showNewAccountContact", checked);
                                                                                        if (checked) {
                                                                                            setFieldValue("showExistingAccountList", false);
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                <FormLabel me={0} className="label" mb="0">
                                                                                    Create New Account:
                                                                                </FormLabel>
                                                                                <Text className="value">{data?.companyName}</Text>
                                                                            </FormControl>

                                                                            {values.showNewAccountContact && !alreadyContactExist && (
                                                                                <Text className="label">A new Contact {data?.leadName} will be created for the Account.</Text>
                                                                            )}
                                                                        </Box>
                                                                    )}
                                                                </>
                                                                :
                                                                <>
                                                                    <Flex gap="6px">
                                                                        <Text className="label">{crmConstant.createNewAcc}:</Text>
                                                                        <Text className="value">{data?.companyName}</Text>
                                                                    </Flex>
                                                                </>
                                                            }

                                                            {alreadyContactExist ?
                                                                <>
                                                                    <Box mt={"6px"}>
                                                                        <Text className="label">Contact with similar details in <b>Contact Name</b> already exist.</Text>
                                                                        <FormControl ref={contactFormControlRef} mt={"16px"} display="flex" gap={"6px"} alignItems="center">
                                                                            <Checkbox
                                                                                name="showExistingContactList"
                                                                                isChecked={values.showExistingContactList}
                                                                                onChange={(e) => {
                                                                                    const checked = e.target.checked;
                                                                                    setFieldValue("showExistingContactList", checked);
                                                                                    if (checked) {
                                                                                        setFieldValue("showNewContact", false);
                                                                                        setShowContactTable(true);
                                                                                    } else {
                                                                                        setShowContactTable(false);
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <FormLabel mr={0} className="label" mb="0">
                                                                                Add to existing Contact
                                                                            </FormLabel>
                                                                            <Text className="value">{data?.leadName}</Text>
                                                                        </FormControl>


                                                                        <FormControl mt={"6px"} display="flex" gap={"6px"} alignItems="center">
                                                                            <Checkbox
                                                                                name="showNewContact"
                                                                                isChecked={values.showNewContact}
                                                                                onChange={(e) => {
                                                                                    const checked = e.target.checked;
                                                                                    setFieldValue("showNewContact", checked);
                                                                                    if (checked) {
                                                                                        setFieldValue("showExistingContactList", false);
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <FormLabel me={0} className="label" mb="0">
                                                                                Create New Contact:
                                                                            </FormLabel>
                                                                            <Text className="value">{data?.leadName}</Text>
                                                                        </FormControl>
                                                                    </Box>
                                                                </>
                                                                :
                                                                <>
                                                                    <Flex gap="6px">
                                                                        <Text className="label">{crmConstant.createNewContact}:</Text>
                                                                        <Text className="value">{data?.leadName}</Text>
                                                                    </Flex>
                                                                </>
                                                            }

                                                            {/* <Flex gap="6px">
                                                                <Text className="label">{crmConstant.owner}:</Text>
                                                                <Text className="value">{user?.firstName}</Text>
                                                            </Flex> */}
                                                        </>



                                                        <Box className="createDealContainer">
                                                            {(
                                                                (!alreadyAccountExist || values.showNewAccountContact || (isAccountConfirmed && values.showExistingAccountList))
                                                            ) && (
                                                                    <FormControl display="flex" gap="6px" alignItems="center">
                                                                        <Checkbox
                                                                            name="showCreateOpportunity"
                                                                            isChecked={values.showCreateOpportunity}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <FormLabel className="label" mb="0">
                                                                            {crmConstant.createNewOpportunity}
                                                                        </FormLabel>
                                                                    </FormControl>
                                                                )}


                                                            {
                                                                (
                                                                    (!alreadyAccountExist || values.showNewAccountContact || (isAccountConfirmed && values.showExistingAccountList))
                                                                ) &&
                                                                values.showCreateOpportunity && (
                                                                    <Box>
                                                                        {/* Amount (Optional) */}
                                                                        <FormControl mb={4} isInvalid={!!errors.amount && touched.amount}>
                                                                            <FormLabel className="label">{crmConstant.amount} <span className="astrick">*</span></FormLabel>
                                                                            <Input
                                                                                name="amount"
                                                                                value={values.amount}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            <FormErrorMessage>{errors.amount}</FormErrorMessage>
                                                                        </FormControl>

                                                                        {/* Deal Name (Required if Checkbox is Checked) */}
                                                                        <FormControl mb={4} isInvalid={!!errors.dealName && touched.dealName}>
                                                                            <FormLabel className="label">{crmConstant.dealName} <span className="astrick">*</span></FormLabel>
                                                                            <Input
                                                                                name="dealName"
                                                                                value={values.dealName}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            <FormErrorMessage>{errors.dealName}</FormErrorMessage>
                                                                        </FormControl>

                                                                        {/* Closing Date (Required if Checkbox is Checked) */}
                                                                        <FormControl mb={4} isInvalid={!!errors.closeDate && touched.closeDate}>
                                                                            <FormLabel className="label">{crmConstant.closeDate}<span className="astrick">*</span></FormLabel>
                                                                            <Input
                                                                                type="date"
                                                                                name="closeDate"
                                                                                value={values.closeDate}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            />
                                                                            <FormErrorMessage>{errors.closeDate}</FormErrorMessage>
                                                                        </FormControl>

                                                                        {/* Stage (Required if Checkbox is Checked) */}
                                                                        <FormControl mb={4} isInvalid={!!errors.stage && touched.stage}>
                                                                            <FormLabel className="label">Stage <span className="astrick">*</span></FormLabel>
                                                                            <Select
                                                                                name="stage"
                                                                                value={values.stage}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                            >
                                                                                <option value="">Select Stage</option>
                                                                                <option value="qualification">Qualification</option>
                                                                                <option value="needsAnalysis">Needs Analysis</option>
                                                                                <option value="valueProposition">Value Proposition</option>
                                                                                <option value="identifyDecisionMakers">Identify Decision Makers</option>
                                                                                <option value="proposal">Proposal</option>
                                                                                <option value="negotiation">Negotiation</option>
                                                                                <option value="closedWon">Closed Won</option>
                                                                                <option value="closedLost">Closed Lost</option>
                                                                                <option value="closedLostToCompetition">Closed Lost to Competition</option>
                                                                            </Select>
                                                                            <FormErrorMessage>{errors.stage}</FormErrorMessage>
                                                                        </FormControl>
                                                                    </Box>
                                                                )
                                                            }
                                                        </Box>

                                                        {(alreadyAccountExist || alreadyContactExist) &&
                                                            <Flex mt={"6px"} gap="6px">
                                                                <Text className="label">{crmConstant.owner}:</Text>
                                                                <Text className="value">{user?.firstName}</Text>
                                                            </Flex>
                                                        }
                                                    </Flex>
                                                </>
                                            )
                                            }
                                        </ModalBody>

                                        <ModalFooter>
                                            <Button sx={{ textTransform: "capitalize" }} variant="outline"
                                                className="cancelBtn theme-btn2"
                                                size="sm" onClick={onClose}>
                                                {constant.cancel}
                                            </Button>
                                            <Button
                                                className="viewEditBtn"
                                                sx={{ textTransform: "capitalize" }}
                                                type="submit"
                                                ml={4}
                                                isDisabled={isSubmitDisabled}
                                            >
                                                {isSubmitting ? <Spinner /> : crmConstant.convert}
                                            </Button>
                                        </ModalFooter>
                                    </Form>
                                    {showTable
                                        &&
                                        <Box ref={tableRef} className="tooltipTable" bg="white" p={4} borderRadius="md" boxShadow="lg">
                                            <Box className="tooltipContainer">

                                                {/* Title */}
                                                <Text className="tooltipTableHeader" fontWeight="bold" fontSize="lg" mb={3}>
                                                    Matching Account Record(s)
                                                </Text>

                                                {/* Table */}
                                                <Box className="tooltipTableBody" overflowX="auto">


                                                    {alreadyAccountExist && accountFieldsValue.length > 0 && (
                                                        <>
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Select</th>
                                                                        {accountFields.map(field => (
                                                                            <th key={field._id}>{field.label}</th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {accountFieldsValue.map((account, idx) => (
                                                                        <tr key={idx}>
                                                                            <td>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedAccountId === account._id}
                                                                                    onChange={() => handleCheckboxChange(account._id)}
                                                                                />
                                                                            </td>
                                                                            {accountFields.map(field => (
                                                                                <td key={field._id}>
                                                                                    {field.type === 'select' ? (
                                                                                        <StatusDropdown
                                                                                            isDisabled={true}
                                                                                            key={field._id}
                                                                                            statusOptions={field.options}
                                                                                            initialStatus={account[field.name]}
                                                                                            color="gray.100"
                                                                                            changeHandler={() => { }} // no-op since it's read-only here
                                                                                        />
                                                                                    ) : (
                                                                                        account[field.name] !== undefined && account[field.name] !== ''
                                                                                            ? account[field.name]
                                                                                            : '-'
                                                                                    )}
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </>
                                                    )}



                                                </Box>

                                                {/* Footer Buttons */}
                                                <Flex className="tooltipTableFooter" justify="flex-end" mt={4} gap={3}>
                                                    <Button onClick={() => {
                                                        setShowTable(false);
                                                        setIsAccountConfirmed(false);
                                                        setFieldValue("showExistingAccountList", false);
                                                        setSelectedAccountId(null);
                                                    }}
                                                        sx={{ textTransform: "capitalize" }}
                                                        variant="outline"
                                                        className="cancelBtn theme-btn2"
                                                        size="sm"
                                                    >
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        onClick={handleDone}
                                                        sx={{ textTransform: "capitalize" }}
                                                        className="viewEditBtn"
                                                        isDisabled={!selectedAccountId}>
                                                        Done
                                                    </Button>
                                                </Flex>

                                            </Box>
                                        </Box>
                                    }


                                    {
                                        showContactTable

                                        &&
                                        <Box ref={tableRef} className="tooltipTable" bg="white" p={4} borderRadius="md" boxShadow="lg">
                                            <Box className="tooltipContainer">

                                                {/* Title */}
                                                <Text className="tooltipTableHeader" fontWeight="bold" fontSize="lg" mb={3}>
                                                    Matching Contact Record(s)
                                                </Text>

                                                {/* Table */}
                                                <Box className="tooltipTableBody" overflowX="auto">


                                                    {alreadyContactExist && contactFieldsValue.length > 0 && (
                                                        <>
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Select</th>
                                                                        {contactFields.map(field => (
                                                                            <th key={field._id}>{field.label}</th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {contactFieldsValue.map((contact, idx) => (
                                                                        <tr key={idx}>
                                                                            <td>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={selectedContactId === contact._id}
                                                                                    onChange={() => handleContactCheckboxChange(contact._id)}
                                                                                />
                                                                            </td>
                                                                            {contactFields.map(field => (
                                                                                <td key={field._id}>
                                                                                    {field.type === 'select' ? (
                                                                                        <StatusDropdown
                                                                                            isDisabled={true}
                                                                                            key={field._id}
                                                                                            statusOptions={field.options}
                                                                                            initialStatus={contact[field.name]}
                                                                                            color="gray.100"
                                                                                            changeHandler={() => { }} // no-op since it's read-only here
                                                                                        />
                                                                                    ) : (
                                                                                        contact[field.name] !== undefined && contact[field.name] !== ''
                                                                                            ? contact[field.name]
                                                                                            : '-'
                                                                                    )}
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </>
                                                    )}



                                                </Box>

                                                {/* Footer Buttons */}
                                                <Flex className="tooltipTableFooter" justify="flex-end" mt={4} gap={3}>
                                                    <Button onClick={() => {
                                                        setShowContactTable(false);
                                                        setIsContactConfirmed(false);
                                                        setFieldValue("showExistingContactList", false);
                                                        setSelectedContactId(null);
                                                    }}
                                                        sx={{ textTransform: "capitalize" }}
                                                        variant="outline"
                                                        className="cancelBtn theme-btn2"
                                                        size="sm"
                                                    >
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        onClick={handleContactDone}
                                                        sx={{ textTransform: "capitalize" }}
                                                        className="viewEditBtn"
                                                        isDisabled={!selectedContactId}>
                                                        Done
                                                    </Button>
                                                </Flex>

                                            </Box>
                                        </Box>
                                    }
                                </ModalContent>
                            </Modal>
                        </Box >
                    </>
                );
            }}
        </Formik >
    );
};

export default ConvertModal;
